/* global $, PhotoSwipe, PhotoSwipeUI_Default: false */
'use strict';

/**
 *  Scroll To Content Button
 */
$( document ).ready(function() {
	'use strict';
	let $photoswipeElement = $('[data-photoswipe-options]');
	if ($photoswipeElement.length > 0) {
		$photoswipeElement.photoswipeLightbox( $photoswipeElement.data('photoswipe-options') );
	}
});

/**
 * Photoswipe Lightbox
 *
 * @param options
 */
$.fn.photoswipeLightbox = function(options) {
	let el = $(this);

	let settings = $.extend({
		closeOnScroll: true,
		escKey: true,
		arrowKeys: true,
		loop: true,
		history: true,
		focus: true,
		modal: true,
		showHideOpacity: true,
		closeEl: true,
		captionEl: true,
		fullscreenEl: true,
		zoomEl: true,
		shareEl: true,
		counterEl: true,
		arrowEl: true,
		preloaderEl: true,
		bgOpacity: 0.7,
	}, options);

	el.each( function() {
		let $pic = $(this),
			getItems = function() {
				let items = [];
				$pic.find('a').each(function() {

					let $href = $(this).data('src'),
						$w = $(this).data('width'),
						$h = $(this).data('height'),
						$msrc = $(this).find('img').attr('src'),
						$title = $(this).data('title'),
						$pid = $(this).data('slug');

					let item = {
						src: $href,
						w: $w,
						h: $h,
						msrc: $msrc,
						title: $title,
						pid: $pid
					};

					items.push(item);

				});

				return items;

			};

		let items = getItems();

		let $pswp = $('.pswp')[0];
		$pic.on('click', 'a', function(event) {
			event.preventDefault();

			let $index = $(this).data('index');
			let options = {
				index: $index,
				bgOpacity: settings.bgOpacity,
				spacing: 0.12,
				allowPanToNext: true,
				pinchToClose: true,
				closeOnScroll: settings.closeOnScroll,
				closeOnVerticalDrag: true,
				escKey: settings.escKey,
				arrowKeys: settings.arrowKeys,
				history: settings.history,
				mouseUsed: false,
				loop: settings.loop,
				focus: settings.focus,
				modal: settings.modal,
				showHideOpacity: settings.showHideOpacity,
				showAnimationDuration: 333,
				hideAnimationDuration: 333,
				closeEl: settings.closeEl,
				captionEl: settings.captionEl,
				fullscreenEl: settings.fullscreenEl,
				zoomEl:  settings.zoomEl,
				shareEl:  settings.shareEl,
				counterEl: settings.counterEl,
				arrowEl: settings.arrowEl,
				preloaderEl:  settings.preloaderEl,
			};

			// Initialize PhotoSwipe
			let lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
			lightBox.init();
		});
	});
};
